import React from 'react';
import { View, Text, StyleSheet, ScrollView, Dimensions } from 'react-native';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTheme } from '../contexts/ThemeContext';

const { width } = Dimensions.get('window');

const DisclaimerScreen = () => {
    const { colors } = useTheme();
    const isMobile = width < 768;

    const styles = StyleSheet.create({
        container: { flex: 1, backgroundColor: colors.background },
        scrollView: { flex: 1 },
        hero: {
            backgroundColor: '#1a1a4e',
            paddingVertical: 60,
            paddingHorizontal: 20,
        },
        heroContent: {
            maxWidth: 800,
            alignSelf: 'center',
            alignItems: 'center',
        },
        heroTitle: {
            fontSize: isMobile ? 28 : 40,
            fontWeight: '800',
            color: '#c9a44e',
            textAlign: 'center',
            marginBottom: 12,
        },
        heroSubtitle: {
            fontSize: 15,
            color: 'rgba(255,255,255,0.7)',
            textAlign: 'center',
        },
        content: {
            paddingVertical: 60,
            paddingHorizontal: 20,
            backgroundColor: '#fff',
        },
        contentContainer: {
            maxWidth: 800,
            alignSelf: 'center',
            width: '100%',
        },
        lastUpdated: {
            fontSize: 14,
            color: '#6b7280',
            marginBottom: 30,
        },
        section: {
            marginBottom: 32,
        },
        sectionTitle: {
            fontSize: 20,
            fontWeight: '700',
            color: '#1a1a4e',
            marginBottom: 12,
        },
        paragraph: {
            fontSize: 15,
            color: '#374151',
            lineHeight: 26,
            marginBottom: 12,
        },
        warningBox: {
            backgroundColor: '#fef3c7',
            borderLeftWidth: 4,
            borderLeftColor: '#f59e0b',
            padding: 16,
            borderRadius: 8,
            marginBottom: 20,
        },
        warningText: {
            fontSize: 14,
            color: '#92400e',
            lineHeight: 22,
        },
    });

    return (
        <View style={styles.container}>
            <Header />
            <ScrollView style={styles.scrollView}>
                <View style={styles.hero}>
                    <View style={styles.heroContent}>
                        <Text style={styles.heroTitle}>Disclaimer</Text>
                        <Text style={styles.heroSubtitle}>Important information about our services and content</Text>
                    </View>
                </View>

                <View style={styles.content}>
                    <View style={styles.contentContainer}>
                        <Text style={styles.lastUpdated}>Last Updated: December 2024</Text>

                        <View style={styles.warningBox}>
                            <Text style={styles.warningText}>
                                The information provided on this website and through our services is for general informational purposes only. It should not be considered as professional tax, legal, or financial advice.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>1. General Disclaimer</Text>
                            <Text style={styles.paragraph}>
                                Modern Munshiji provides accounting, tax filing, and business registration services. While we make every effort to ensure accuracy, we cannot guarantee that all information is complete, accurate, or up-to-date at all times.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>2. No Professional Advice</Text>
                            <Text style={styles.paragraph}>
                                The content on this website, including calculators and tools, is provided for informational purposes. It does not constitute professional tax, legal, or financial advice. For specific advice, please consult with qualified professionals.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>3. Calculator Accuracy</Text>
                            <Text style={styles.paragraph}>
                                Our financial calculators are designed to provide approximate estimates based on the information you provide. Actual results may vary due to changes in tax laws, rates, and individual circumstances. Always verify calculations before making financial decisions.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>4. Third-Party Links</Text>
                            <Text style={styles.paragraph}>
                                Our website may contain links to third-party websites. We are not responsible for the content, accuracy, or practices of these external sites.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>5. Changes in Regulations</Text>
                            <Text style={styles.paragraph}>
                                Tax laws and regulations are subject to change. While we strive to stay updated, there may be delays in reflecting the latest changes on our website. Always refer to official government sources for the most current information.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>6. Limitation of Liability</Text>
                            <Text style={styles.paragraph}>
                                Modern Munshiji shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of our website, services, or reliance on information provided. Users assume full responsibility for their actions based on information obtained from our services.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionTitle}>7. Contact</Text>
                            <Text style={styles.paragraph}>
                                If you have any questions about this disclaimer, please contact us at support@modernmunshiji.com
                            </Text>
                        </View>
                    </View>
                </View>

                <Footer />
            </ScrollView>
        </View>
    );
};

export default DisclaimerScreen;
